export default {
      id: "mask_compo2-usage",
      viewBox: "0 0 100 400",
      url: "../dist/images/" + "sprite.svg#mask_compo2-usage",
      toString: function () {
        return this.url;
      }
    }